export function obscureText(text: string, visibleChars = 4): string {
  const obscuredPart = "*".repeat(text.length - visibleChars); // Replace with asterisks
  const visiblePart = text.slice(-visibleChars); // Keep the last few characters visible
  return obscuredPart + visiblePart;
}
